module.exports = __webpack_public_path__ + "static/maquina-8a2695283bf9d001c498ed3cd15d7aa3.jpg";